export default "__VITE_ASSET__D0vw3vPr__"